"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M15.822 7.2H8.178a.978.978 0 00-.977.977v7.646c0 .54.438.977.977.977h7.646c.54 0 .977-.438.977-.978V8.178a.978.978 0 00-.978-.977zM8.12 15.68l2.028-2.56.928 1.171 1.855-2.342 2.956 3.731H8.12z" }), "Image");
//# sourceMappingURL=Image.js.map